export default __webpack_public_path__ + "static/media/uipath-logo.c32e3c36.svg";